export default __webpack_public_path__ + "static/media/img-0557-denmark-premium-face.ca2d6b45.png";